import { createContext, useContext } from "react"

import type { AnnotationValue } from "@/constants/annotation-values"

export type ValueChangeCallback = (value: AnnotationValue | null) => void
export type NumericalFocusCallback = (initialKey?: string) => void

interface TableFocusContextType {
  selectedMetricId: string | null
  setSelectedMetricId: (metricId: string | null) => void
  focusedMetricId: string | null
  setFocusedMetricId: (metricId: string | null) => void
  registerValueChangeCallback: (
    metricId: string,
    callback: ValueChangeCallback,
  ) => void
  unregisterValueChangeCallback: (metricId: string) => void
  registerNumericalFocusCallback: (
    metricId: string,
    callback: NumericalFocusCallback,
  ) => void
  unregisterNumericalFocusCallback: (metricId: string) => void
}

export const TableFocusContext = createContext<
  TableFocusContextType | undefined
>(undefined)

export const useTableFocus = () => {
  const context = useContext(TableFocusContext)
  if (!context) {
    throw new Error("useTableFocus must be used within TableFocusProvider")
  }
  return context
}

export const useTableFocusSafe = () => useContext(TableFocusContext)
